import { render, staticRenderFns } from "./PayRunReportPrint.vue?vue&type=template&id=12085e28&"
import script from "./PayRunReportPrint.vue?vue&type=script&lang=js&"
export * from "./PayRunReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports